module.exports = __webpack_public_path__ + "app-static/img/dzf.fe5ea2cd.png";